const food = {
  getlist: 'food/getlist-by-admin',
  add: 'food/add',
  update: 'food/update',
  remove: 'food/remove',
  get: 'food/get-by-admin',
  getall: 'food/getall',
  clearcache: 'food/clear-cache',
}
export default food
